import { useUserBonusById } from '@/api/user-bonus';
import { useSearchParams } from '@starsoft/common/hooks';
import { UseUserBonusByIdWithParamsProps } from './props';

export function useUserBonusByIdWithParams(
  options?: UseUserBonusByIdWithParamsProps,
) {
  const params: URLSearchParams = useSearchParams();
  const bonusId = params.get('user_bonus_id');
  return useUserBonusById({
    id: Number(bonusId),
    refetchOnMount: options?.refetchOnMount,
  });
}
